// Lifted from useSequentialTableColumns; pure so basic-output can reuse without React/Jotai.

import * as R from 'remeda'

import {
  type ColumnInfo,
  getDiffKey,
  type GroupAndAll,
  groupsAndAll,
} from '~/utils'

import {
  getColumnInfos,
  type GroupsDiff,
  type GroupsDiffColumnKey,
} from './common'
import { type SequentialColumnKey } from './sequential'

const widthMap: Record<
  Exclude<SequentialColumnKey, GroupsDiffColumnKey>,
  string
> = {
  questionText: 'max-content',
  answerText: 'max-content',
  ...R.mapToObj(groupsAndAll, (group) => [group, '5.5em']),
}

export const buildSequentialTableColumns = ({
  groupsDiffs,
  tabulatedGroupsAndAll,
}: {
  groupsDiffs: ReadonlyArray<GroupsDiff>
  tabulatedGroupsAndAll: ReadonlyArray<GroupAndAll>
}): ColumnInfo<SequentialColumnKey>[] => {
  const columnKeys: SequentialColumnKey[] = [
    'questionText',
    'answerText',
    ...tabulatedGroupsAndAll,
    ...groupsDiffs.map(getDiffKey),
  ]

  return getColumnInfos(columnKeys, widthMap)
}
